<template>
  <div>
    <div class="page-header">
      <div class="add-item d-flex">
        <div class="page-title">
          <h4>{{ $t("invoice_setting") }}</h4>
        </div>
      </div>
<!--		<ul class="table-top-head">-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Pdf"><img src="/assets/img/icons/pdf.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Excel"><img src="/assets/img/icons/excel.svg" alt="img"></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Print"><i class="ti ti-printer"></i></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Refresh"><i class="ti ti-refresh"></i></a>-->
<!--			</li>-->
<!--			<li>-->
<!--				<a data-bs-toggle="tooltip" data-bs-placement="top" title="Collapse" id="collapse-header"><i class="ti ti-chevron-up"></i></a>-->
<!--			</li>-->
<!--		</ul>-->
      <div class="page-btn" v-if="!settings.length">
        <router-link to="/invoice/setting/create" class="btn btn-added">
          <i class="ti ti-circle-plus me-2 text-white"></i>{{ $t("add_new_setting") }}
        </router-link>
      </div>
	</div>
	<!-- /product list -->
	<div class="card table-list-card">
		<div class="card-body">

			<div class="table-responsive">
        <DataTable v-if="settings.length" :tableId="'settingsTable'" class="table align-middle">
          <thead>
            <tr>
              <th class="text-start">{{ $t("business_name") }}</th>
              <th class="text-start">{{ $t("business_phone") }}</th>
              <th class="text-start">{{ $t("show_tin") }}</th>
              <th class="text-start">{{ $t("show_bin") }}</th>
              <th class="text-start">{{ $t("show_logo") }}</th>
              <th class="text-center">{{ $t("action") }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="setting in settings" :key="setting.id">
              <td class="text-start">{{ setting.business_name }}</td>
              <td class="text-start">{{ setting.business_phone }}</td>
              <td class="text-center">
                <span class="badge bg-success" v-if="setting.show_tin">
                  YES
                </span>
                <span class="badge bg-danger" v-else>
                  NO
                </span>
              </td>
              <td class="text-center">
                <span class="badge bg-success" v-if="setting.show_bin">
                  YES
                </span>
                <span class="badge bg-danger" v-else>
                  NO
                </span>
              </td>
              <td class="text-center">
                <span class="badge bg-success" v-if="setting.show_logo">
                  YES
                </span>
                <span class="badge bg-danger" v-else>
                  NO
                </span>
              </td>

              <td class="text-center">
                <router-link v-if="can('inventory.configuration', 'E')" :to= "{name:'InvoiceSettingEdit',params:{id:setting.id}}"
                 class="btn btn-added" >
                  <i class="ti ti-edit me-2"></i>{{ $t("edit_setting") }}
                </router-link>
              </td>
            </tr>
          </tbody>
        </DataTable>
        <!-- If No Data -->
        <div v-else class="d-flex flex-column align-items-center justify-content-center p-5 bg-light rounded shadow-sm">
          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="#6c757d" class="mb-3" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 0 8 8A8.009 8.009 0 0 0 8 0zm0 15A7 7 0 1 1 15 8a7.008 7.008 0 0 1-7 7z"/>
            <path d="M5.354 4.646a.5.5 0 0 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z"/>
          </svg>
          <h5 class="text-muted">No Data Found</h5>
          <p class="text-secondary small">Try adjusting filters or add new data.</p>
        </div>
      </div>
		</div>
	</div>
<!-- /product list -->

  </div>
</template>

<script>
import apiUrls from '@/urls';
import DataTable from '@/components/common/DataTable.vue';
import InvSettingEdit from "@/views/admin_dashboard/inv_setting/InvSettingEdit";
import { hasPermission } from "@/helpers/permission"

export default {
  inject: ['globalLoading'],
  components: {
    DataTable,
    InvSettingEdit
  },
  data() {
    return {
      settings: [],
    };
  },

  methods: {
    async fetchSettings() {
      this.globalLoading(true);
      try {
        const { data } = await this.$axios.get(apiUrls.invoice_setting.get);
        this.settings = data;
      } catch (error) {
        console.error("Error fetching invoice settings:", error);
      } finally {
        this.globalLoading(false);
      }
    },

    can(code, level) {
      return hasPermission({ code, level });
    },
  },

  created() {
    this.fetchSettings();
  }
};
</script>
